<div class="map-container">
    <div class="map-frame">
      <div id="map"></div>
    </div>
</div>